import React from "react";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";
import Button from "./Button";
import { cn } from "./cn";

/**
 * Paginación compartida (antes duplicada en 5 pantallas con botones sólidos
 * brand-500). Es un control secundario, así que baja a `secondary` y el foco
 * queda en el contenido de la tabla.
 */
export interface PaginationProps {
  pageIndex: number;
  pageCount: number;
  canPreviousPage: boolean;
  canNextPage: boolean;
  onPreviousPage: () => void;
  onNextPage: () => void;
  /** Con una sola página los dos botones estarían siempre inactivos: se oculta. */
  hideWhenSinglePage?: boolean;
  className?: string;
}

const Pagination: React.FC<PaginationProps> = ({
  pageIndex,
  pageCount,
  canPreviousPage,
  canNextPage,
  onPreviousPage,
  onNextPage,
  hideWhenSinglePage = true,
  className,
}) => {
  const total = pageCount === 0 ? 1 : pageCount;
  if (hideWhenSinglePage && total <= 1) return null;

  return (
    <nav
      aria-label="Paginación"
      className={cn("flex items-center justify-center gap-2", className)}
    >
      <Button
        size="sm"
        variant="secondary"
        onClick={onPreviousPage}
        disabled={!canPreviousPage}
        aria-label="Página anterior"
        leftIcon={<MdChevronLeft className="h-4 w-4" />}
      >
        Anterior
      </Button>

      <span className="tabular select-none px-2 text-[13px] font-medium text-gray-700 dark:text-gray-300">
        {pageIndex + 1} <span className="text-gray-600">/</span> {total}
      </span>

      <Button
        size="sm"
        variant="secondary"
        onClick={onNextPage}
        disabled={!canNextPage}
        aria-label="Página siguiente"
        rightIcon={<MdChevronRight className="h-4 w-4" />}
      >
        Siguiente
      </Button>
    </nav>
  );
};

export default Pagination;
